import DTO from './DTO';

class NotificationTemplateRegistryDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'notification.template.name',
      },
      {
        name: 'type',
        type: String,
        validators: {},
        labelKey: 'notification.template.reasons_type',
      },
      {
        name: 'procedures',
        type: String,
        validators: {},
        labelKey: 'notification.template.procedures',
      },
      {
        name: 'application_status',
        type: String,
        validators: {},
        labelKey: 'notification.template.application_status',
      },
      {
        name: 'registries',
        type: String,
        validators: {},
        labelKey: 'notification.template.registries',
      },
      {
        name: 'registry_status',
        type: String,
        validators: {},
        labelKey: 'notification.template.registry_status',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'status',
      },
      {
        name: 'is_statement',
        type: Boolean,
        validators: {},
        labelKey: 'notification.template.is_statement',
      },
      {
        name: 'message',
        type: String,
        validators: {},
        labelKey: 'notification.template.message',
      },
      {
        name: 'creator_id',
        type: String,
        validators: {},
        labelKey: 'creator_id',
      },
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'created_at',
      },
    ];

    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default NotificationTemplateRegistryDTO;
